/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    disabled: PropTypes.bool,
    done: PropTypes.bool,
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'a',
    disabled: false,
    done: false,
};

const ProgressStep = (props) => {
    const classNames = [
        'c-progress-step',
        props.done ? 'c-progress-step--done' : '',
        props.disabled ? 'c-progress-step--disabled' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            title={`Aller à l'étape : ${props.text}`}
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <div className="c-progress-step__icon">
                {props.icon}
            </div>
            <div className="c-progress-step__text">
                {props.text}
            </div>
        </props.componentClass>
    );
};

ProgressStep.propTypes = propTypes;

ProgressStep.defaultProps = defaultProps;

export default ProgressStep;
